import React from 'react';
import CalendarLines from '../SVGs/CalendarLines';

const ProgressBar = (props) => {
  let { bgcolor, completed, isCalendar = false, bgImage } = props;
  completed = parseInt(completed) > 100 ? '100' : completed;
  const containerStyles = {
    height: isCalendar ? 8 : 14,
    width: '100%',
    backgroundColor: isCalendar ? 'transparent' : '#f1f1f1',
    borderRadius: 50,
    margin: '0 auto',
  };
  const fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    backgroundColor: bgcolor,
    backgroundImage: bgImage,
    borderRadius: 'inherit',
    textAlign: 'right',
  };
  const labelStyles = {
    padding: 5,
    color: 'white',
    fontWeight: 'bold',
  };
  return (
    <div style={containerStyles} className='UsageProgressBar'>
      <div style={fillerStyles}></div>
      <span style={labelStyles}>{isCalendar ? <CalendarLines /> : ''}</span>
    </div>
  );
};
export default ProgressBar;
